<template>
  <div>
    <generic-container
      :title="$t('projects')"
      icon="project diagram"
      :searchable="true"
      :show_plus="true"
      v-on:add="add"
      v-on:filter="filter"
      :header_buttons="header_buttons"
    >
      <div class="ui two link cards" style="padding: 50px 80px">
        <div
          class="card"
          v-for="(item, index) in projects"
          v-bind:key="index"
          v-on:click="select_project(item)"
        >
          <div class="content">
            <i class="ui project diagram right floated icon"></i>
            <div class="header">{{ item.name }}</div>
            <div class="description">{{ item.description }}</div>
            <div class="meta">
              <span>{{
                item.create_date
                  | formatDate(enterprise_setup.simple_date_format)
              }}</span>
            </div>
            <p></p>
          </div>
          <div class="ui bottom attached basic buttons">
            <div
              data-inverted
              :data-tooltip="$t('edit')"
              class="ui button"
              v-on:click.stop="edit(item)"
            >
              <i class="ui edit icon"></i>
            </div>
            <div
              data-inverted
              :data-tooltip="$t('export')"
              class="ui button"
              @click.stop="export_project(item)"
            >
              <i class="ui cloud download icon"></i>
            </div>
            <div
              data-inverted
              :data-tooltip="$t('delete')"
              class="ui button"
              @click.stop="remove(item, index)"
            >
              <i class="ui red trash icon"></i>
            </div>
          </div>
        </div>
      </div>
    </generic-container>
    <template v-for="(mdl, index) in popup_modals">
      <component
        :is="mdl"
        :key="index"
        :project="selected_project"
        v-on:destroy="destroy"
        v-on:succedded="succedded"
      ></component>
    </template>
  </div>
</template>

<script>
import {
  local_api,
  clone,
  error_toast,
  success_toast,
  enterprise_setup,
} from "@/utils";
import filters from "@/filters";
import GenericContainer from "@/components/GenericContainer";
// import ConfigureModal from "./ConfigureModal";
import ProjectModal from "./ProjectModal";
import ProjectImportModal from "./ProjectImportModal";

// @ is an alias to /src
export default {
  name: "ProjectManagement",
  components: {
    "generic-container": GenericContainer,
    // ConfigureModal
  },
  filters: filters,
  data() {
    return {
      selected_project: {},
      projects: [],
      all_projects: [],
      popup_modals: [],
      modal_origin: "",
      header_buttons: [
        {
          icon: "cloud upload",
          click: this.import_project,
          tooltip: this.$t("import"),
        },
      ],
      // configure_modal: ConfigureModal
    };
  },
  computed: {
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  methods: {
    add() {
      this.modal_origin = "add";
      this.popup_modals.push(ProjectModal);
    },
    edit(project) {
      this.modal_origin = "edit";
      this.selected_project = project;
      this.popup_modals.push(ProjectModal);
    },
    succedded(project) {
      if (this.modal_origin != "deploy") {
        let trgtIdx = this.projects.findIndex(
          (n) => n.project_id == project.project_id,
        );
        if (trgtIdx == -1) {
          this.projects.push(project);
        } else {
          this.projects.splice(trgtIdx, 1, project);
        }
      } else {
        success_toast(this.$t("project deployed successfully"));
      }
    },
    destroy() {
      this.popup_modals = [];
      this.import_project_modals = [];
      this.selected_project = {};
    },
    filter(filter) {
      // console.log(filter);
      if (filter == "") this.projects = clone(this.all_projects);
      else
        this.projects = this.all_projects.filter(
          (n) =>
            n.name.toUpperCase().includes(filter.toUpperCase()) ||
            n.description.toUpperCase().includes(filter.toUpperCase()),
        );
    },
    select_project(project) {
      // this.customer = customer;
      this.$router.push({
        name: "PixelArtProjectIndex",
        query: { i: project.uuid },
      });
      // this.customer_modals.push(CustomerModal);
    },
    remove(project, index) {
      let vm = this;
      this.$alertify.confirm(
        this.$t("are you sure to remove project?"),
        function() {
          local_api(vm, "post", "/pixel_art/project/do-remove", {
            u: project.uuid,
          })
            .then(() => {
              vm.projects.splice(index, 1);
            })
            .catch((err) => {
              error_toast(err);
            });
        },
      );
    },
    export_project(project) {
      console.log("still to do project export", project);
      // let to_export = clone(project);
      // delete to_export.project_id;
      // delete to_export.enterprise_id;
      // delete to_export.create_date;
      // delete to_export.create_user_id;
      // // to_export.setup = JSON.parse(to_export.setup);
      // var blob = new Blob([JSON.stringify(to_export, null)], {
      //   type: "application/json;charset=utf-8",
      // });
      // var url = URL.createObjectURL(blob);
      // var elem = document.createElement("a");
      // elem.href = url;
      // elem.download = `export_${project.name}_${Date.now()}.ngine`;
      // document.body.appendChild(elem);
      // elem.click();
      // document.body.removeChild(elem);
    },
    import_project() {
      this.modal_origin = "import";
      this.popup_modals.push(ProjectImportModal);
    },
  },
  mounted() {
    local_api(this, "post", "/pixel_art/project/do-get-all")
      .then((projects) => {
        let _projects = projects.sort(function(a, b) {
          if (a.name > b.name) return 1;
          if (b.name > a.name) return -1;
          return 0;
        });
        this.projects = _projects.map((p) => {
          p.setup = JSON.parse(p.setup);
          return p;
        });
        this.all_projects = clone(_projects);
      })
      .catch((err) => {
        window.jQuery(this.$el).toast({
          message: err,
          class: "error",
          showImage: "/images/error.png",
          classImage: "avatar",
          title: "Error",
          showProgress: "bottom",
          classProgress: "blue",
        });
      });
  },
  watch: {},
};
</script>
